// src/resultsData.js

const playerData = [
  
  { name: 'Mephissadiablo', EP: 4, matchesPlayed: 0, wins: 0, currentTeam: 'Rage against the Aliens' },
  { name: 'raaf12', EP: 4, matchesPlayed: 0, wins: 0, currentTeam: 'Rage against the Aliens' },
  
  { name: 'Ciber_Monke', EP: 7, matchesPlayed: 0, wins: 0, currentTeam: 'TheHermits' },
  { name: '.bintro', EP: 7, matchesPlayed: 0, wins: 0, currentTeam: 'TheHermits' },
  
  { name: 'davy', EP: 24, matchesPlayed: 4, wins: 2, currentTeam: 'Dad FPS & The Dial-Up kid' },
  { name: 'Koi', EP: 24, matchesPlayed: 4, wins: 2, currentTeam: 'Dad FPS & The Dial-Up kid' },
  
  { name: 'bikaruu', EP: 14, matchesPlayed: 4, wins: 2, currentTeam: 'two eggs, one kol and a pure eradica' },

  { name: 'Duckeh', EP: 11, matchesPlayed: 4, wins: 1, currentTeam: 'I`d sin for that solar empire' },
  { name: 'ncc', EP: 11, matchesPlayed: 4, wins: 1, currentTeam: 'I`d sin for that solar empire' },
  { name: 'thor941', EP: 9, matchesPlayed: 3, wins: 1, currentTeam: 'I`d sin for that solar empire' },

  { name: 'Zabik2', EP: 31, matchesPlayed: 4, wins: 4, currentTeam: 'LirTnolikSimcler2xdd' },
  { name: 'Trolik', EP: 31, matchesPlayed: 4, wins: 4, currentTeam: 'LirTnolikSimcler2xdd' },
  { name: 'Lear_the_cat', EP: 29, matchesPlayed: 4, wins: 4, currentTeam: '-' },


  { name: 'mathematico', EP: 23, matchesPlayed: 4, wins: 3, currentTeam: 'The nameless ones' },
  { name: 'auqia', EP: 23, matchesPlayed: 4, wins: 3, currentTeam: 'The nameless ones' },
  { name: 'Brutalslayer', EP: 23, matchesPlayed: 4, wins: 3, currentTeam: 'The nameless ones' },

  { name: 'naviomg', EP: 20, matchesPlayed: 4, wins: 3, currentTeam: 'Bankstreet Boys' },
  { name: 'doucit', EP: 20, matchesPlayed: 4, wins: 3, currentTeam: 'Bankstreet Boys' },
  { name: 'Crimeskin', EP: 15, matchesPlayed: 3, wins: 3, currentTeam: 'Bankstreet Boys' },

  { name: 'Avezearth', EP: 20, matchesPlayed: 3, wins: 2, currentTeam: 'SOMA' },
  { name: 'Matheus[BRz]L', EP: 10, matchesPlayed: 0, wins: 0, currentTeam: 'SOMA' },
  
  { name: 'Kissblade', EP: 10, matchesPlayed: 3, wins: 1, currentTeam: 'Suneaters' },
  { name: 'Zergrusher/L', EP: 3, matchesPlayed: 1, wins: 0, currentTeam: 'Suneaters' },
  { name: 'AceFaxon', EP: 3, matchesPlayed: 1, wins: 0, currentTeam: 'Suneaters' },

  { name: 'fruitwing', EP: 12, matchesPlayed: 4, wins: 1, currentTeam: 'Panda' },
  { name: '风 暴 领 域 大 神', EP: 12, matchesPlayed: 4, wins: 1, currentTeam: 'Panda' },

  { name: 'Fenix盛', EP: 54, matchesPlayed: 4, wins: 1, currentTeam: 'The Singer' },
  { name: 'galaxenter', EP: 42, matchesPlayed: 0, wins: 0, currentTeam: 'The Singer' },
  { name: 'lagenaz', EP: 42, matchesPlayed: 0, wins: 0, currentTeam: 'The Singer' },
  { name: 'UED', EP: 42, matchesPlayed: 0, wins: 0, currentTeam: 'The Singer' },  

  { name: 'dannyvye.com', EP: 22, matchesPlayed: 0, wins: 0, currentTeam: 'Fleet CMD' },
  { name: 'MonMon', EP: 22, matchesPlayed: 0, wins: 0, currentTeam: 'Fleet CMD' },
  { name: 'holo_icy_holo', EP: 32, matchesPlayed: 4, wins: 2, currentTeam: '' },

  { name: 'Marvin', EP: 11, matchesPlayed: 0, wins: 0, currentTeam: 'TooSlow' },
  { name: 'Harkon Thorson', EP: 11, matchesPlayed: 0, wins: 0, currentTeam: 'TooSlow' },

  { name: 'CCC小白', EP: 19, matchesPlayed: 4, wins: 3, currentTeam: 'Loong' },
  { name: 'X-Wing', EP: 19, matchesPlayed: 4, wins: 3, currentTeam: 'Loong' },
  { name: '黎梦秋年F', EP: 19, matchesPlayed: 4, wins: 3, currentTeam: 'Loong' },

  { name: 'SilasPT', EP: 6, matchesPlayed: 3, wins: 0, currentTeam: 'ISS' },
  { name: 'pakss', EP: 6, matchesPlayed: 3, wins: 0, currentTeam: 'ISS' },
  { name: 'kabianmazorca', EP: 6, matchesPlayed: 3, wins: 0, currentTeam: 'ISS' },

  
  { name: 'Air', EP: 42, matchesPlayed: 4, wins: 1, currentTeam: 'Frontier Negotiator' },
  { name: 'aqua995', EP: 49, matchesPlayed: 4, wins: 1, currentTeam: 'Frontier Negotiator' },
  { name: 'Fellingus', EP: 46, matchesPlayed: 3, wins: 1, currentTeam: 'Frontier Negotiator' },
];

export default playerData;


